<template>
  <div class="source-lists animate__animated animate__fadeIn">
    <div class="widget-12-search">
      <div class="col-md-12 p-l-0 p-r-0">
        <div class="row">
          <div class="m-t-5 m-b-5 col-md-11">
            <h4 class="m-b-0">
              {{ title }}
            </h4>
            <p class="small hint-text">
              {{ subTitle }}
            </p>
          </div>
          <div v-if="collapse" class="p-t-15 col-md-1">
            <i
              v-if="collapseDefault === 'none'"
              class="bi bi-chevron-down clickable hoverable"
              style="cursor: pointer"
              @click="showCardContent"
            />
            <i
              v-else
              class="bi bi-chevron-up clickable hoverable"
              style="cursor: pointer"
              @click="showCardContent"
            />
          </div>
        </div>
      </div>
      <div class="clearfix" />
    </div>
    <div class="company-stat-boxes" :style="'display: ' + collapseDefault">
      <loader-component v-if="isLoading || lists == null" />
      <div
        v-else
        v-for="(source, index) in lists"
        :key="index"
        :data-index="index"
        class="company-stat-box active p-l-5 p-r-5 p-t-10 p-b-10 b-b b-grey"
      >
        <div class="pull-left">
          <p
            class="company-name pull-left text-uppercase bold no-margin"
            style="
              display: flex;
              justify-content: center;
              align-items: center;
              height: 20px;
              width: 100%;
            "
          >
            <span
              style="font-size: 18px"
              class="mr-1"
              :class="source.icon + ' icon-' + source.name.toLowerCase()"
            />
            <span
              style="
                vertical-align: middle !important;
                display: inline-block;
                line-height: normal;
                text-transform: capitalize;
                font-size: 14px;
              "
            >
              {{ source.name }}
            </span>
          </p>
        </div>
        <div class="pull-right">
          <p class="bold no-margin inline thousand-separator">
            {{ thousand_separator(source.count) }}
            <span class="fs-10" v-if="source.dalam_kurung"
              >({{ source.dalam_kurung }})</span
            >
          </p>
        </div>
        <div class="clearfix" />
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import general_plugin from "@/plugins/generalPlugins.js";
import loader_component from "@/views/components/loader.vue";
export default {
  name: "source_list",
  components: {
    "loader-component": loader_component,
  },
  props: {
    title: {
      type: String,
      description: "List Title",
    },
    subTitle: String,
    lists: Array,
    collapse: String,
    collapseDefault: String,
    isLoading: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
  },
  methods: {
    thousand_separator: function (str) {
      return general_plugin.thousandSeparator(str);
    },
    showCardContent: function (event) {
      var card_header = $(event.target).closest(".widget-12-search");
      var isVisible = card_header.next().css("display");
      if (isVisible == "none") {
        card_header.next().slideDown();
        $(event.target).removeClass("bi bi-chevron-down");
        $(event.target).addClass("bi bi-chevron-up");
      } else {
        card_header.next().slideUp();
        $(event.target).removeClass("bi bi-chevron-up");
        $(event.target).addClass("bi bi-chevron-down");
      }
    },
  },
};
</script>

<style scoped>
.fa,
.fas,
.far,
.fab {
  font-size: 25px;
  margin-right: 5px;
  width: 20px;
}
@import "../../../public/assets/plugins/bootstrap-social/bootstrap-social.css";
</style>